import { render, staticRenderFns } from "./AgeProfile.vue?vue&type=template&id=8d0c2bdc&"
import script from "./AgeProfile.vue?vue&type=script&lang=ts&"
export * from "./AgeProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports